import { create } from 'zustand'

export interface FigmaPage { id: string; name: string; imageUrl: string }

interface FigmaStore {
  pages: FigmaPage[]
  setPages: (pages: FigmaPage[]) => void
  figmaUrl: string
  setFigmaUrl: (url: string) => void
  token: string
  setToken: (t: string) => void
  selectedNode: string
  setSelectedNode: (id: string) => void
  code: string
  setCode: (c: string) => void
  appendCode: (c: string) => void
  loading: boolean
  setLoading: (l: boolean) => void
  error: string
  setError: (e: string) => void
  reset: () => void
}

export const useFigmaStore = create<FigmaStore>((set) => ({
  pages: [],
  setPages: (pages) => set({ pages }),
  figmaUrl: '',
  setFigmaUrl: (figmaUrl) => set({ figmaUrl }),
  token: localStorage.getItem('pulse-figma-token') || '',
  setToken: (token) => { localStorage.setItem('pulse-figma-token', token); set({ token }) },
  selectedNode: '',
  setSelectedNode: (selectedNode) => set({ selectedNode }),
  code: '',
  setCode: (code) => set({ code }),
  appendCode: (c) => set((s) => ({ code: s.code + c })),
  loading: false,
  setLoading: (loading) => set({ loading }),
  error: '',
  setError: (error) => set({ error }),
  reset: () => set({ pages: [], selectedNode: '', code: '', error: '', loading: false }),
}))
